import { PlayerLoginLog } from "@/types";
import { ColumnDef } from "@tanstack/react-table";

export const loginLogColumns: ColumnDef<PlayerLoginLog>[] = [
  { accessorKey: "id", header: "Log ID" },
  { accessorKey: "playerId", header: "Player ID" },
  { accessorKey: "username", header: "Player Name" },
  { accessorKey: "ipAddress", header: "IP Address" },
  {
    accessorKey: "timestamp",
    header: "Login Time",
    cell: ({ row }) => new Date(row.original.timestamp).toLocaleString("en-IN"),
  },
];
